/* import React from 'react'
import { FixedRuleTable } from 'components/table/fixed_rule/fixedRuleTable'

const FixedRule = () => {
    return (
        <>
            <FixedRuleTable/>
        </>
    )
}

export { FixedRule } */
import { FixedRuleTable } from "components/table/fixed_rule/Table";

export const FixedRule = () => {
    return (
        <div>
            <FixedRuleTable />
        </div>
    )
}
